import { DefaultErrorSummaryComponent } from "./components/error-summary/templates/default-error-summary/default-error-summary.component";
import { DefaultFooterComponent } from "./components/footer/templates/default/default-footer.component";
import { SkyFooterComponent } from "./components/footer/templates/sky/sky-footer.component";
import { DefaultMobileNavComponent } from "./components/mobile-nav/templates/default-mobile-nav/default-mobile-nav.component";
import { SkyMobileNavComponent } from "./components/mobile-nav/templates/sky-mobile-nav/sky-mobile-nav.component";
import { SkyNavComponent } from "./components/nav/templates/sky/sky-nav.component";
import { DefaultNavComponent } from "./components/nav/templates/default/default-nav.component";
import { SocialNavComponent } from "./components/nav/templates/social/social-nav.component";
import { DefaultUnsubscribeComponent } from "./components/unsubscribe/templates/default-unsubscribe/default-unsubscribe.component";
import { DefaultUploadFileComponent } from "./components/upload-file/templates/default-upload-file/default-upload-file.component";

//Note: "mobile-nav" does not have an actual component (config) in the database, but piggybacks off of "nav".
export const coreComponentDef = {
    "nav": {
        "social": SocialNavComponent,
        "default": DefaultNavComponent,
        "sky": SkyNavComponent
    },
    "mobile-nav": {
        "default": DefaultMobileNavComponent,
        "social": DefaultMobileNavComponent,
        "sky": SkyMobileNavComponent
    },
    "footer": {
        "default": DefaultFooterComponent,
        "social": DefaultFooterComponent,
        "sky": SkyFooterComponent
    },
    "error-summary": {
        "default": DefaultErrorSummaryComponent,
        "social": DefaultErrorSummaryComponent,
        "sky": DefaultErrorSummaryComponent
    },
    "unsubscribe": {
        "default": DefaultUnsubscribeComponent,
        "social": DefaultUnsubscribeComponent,
        "sky": DefaultUnsubscribeComponent
    },
    "upload-file": {
        "default": DefaultUploadFileComponent,
        "social": DefaultUploadFileComponent,
        "sky": DefaultUploadFileComponent
    }
}